import userflow from 'userflow.js'

/**
 * Hands the bottom-right corner back and forth between Userflow's resource center and a
 * third-party widget that lives in the same spot (HubSpot chat, the GitBook docs embed).
 *
 * Call with `false` before showing the other widget, and `true` once it closes so the user
 * lands back on the Userflow resource center they opened it from.
 */
export function setUserflowVisible(visible: boolean) {
  try {
    userflow.setResourceCenterLauncherHidden(!visible)
    if (visible) {
      userflow.openResourceCenter()
    } else {
      userflow.closeResourceCenter()
    }
  } catch {
    // Fallback to CSS if userflow not initialized
    const el = document.getElementById('userflow-ui')
    if (el) el.style.display = visible ? '' : 'none'
  }
}
